import * as React from 'react';
import { FeedbackRibbon, FeedbackDialogParams, FeedbackCategory } from 'owa-feedback';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    translationFeedbackRibbonMessage,
    translationFeedbackThankYouMessage,
    translationFeedbackMoreFeedbackMessage,
    translationFeedbackDialogTitle,
    translationFeedbackDialogSubtitle,
    translationFeedbackDialogGhostText,
    translationFeedbackCategoryReadability,
    translationFeedbackCategoryFormatting,
    translationFeedbackCategoryIncorrectDifficult,
    translationFeedbackCategoryMissingIncomplete,
    translationFeedbackCategoryAlreadyLang,
    translationFeedbackCategoryOther,
    translationFeedbackDonationMessage,
} from './TranslationFeedbackRibbon.locstring.json';
import loc from 'owa-localize';

const styles = require('./TranslationFeedbackRibbon.scss');

export interface TranslationFeedbackRibbonProps {
    messageContent: string;
    translationData;
}

function onYes() {
    //TODO: log to microfeedback API
}

function onNo() {
    //TODO: log to microfeedback API
}

function getMetadata(props: TranslationFeedbackRibbonProps) {
    const translationFeedbackRibbonMetadata = {
        correlationId: props.translationData.correlationId,
        sourceLanguage: props.translationData.itemOgmaLocale,
        targetLanguage: props.translationData.targetLanguageTag,
        messageLength: props.messageContent.length,
    };
    return JSON.stringify(translationFeedbackRibbonMetadata);
}

export default function TranslationFeedbackRibbon(props: TranslationFeedbackRibbonProps) {
    const feedbackCategories: FeedbackCategory[] = isFeatureEnabled(
        'rp-inlineTranslation-feedbackRibbon-newCategories'
    )
        ? [
              {
                  logString: 'IncorrectDifficult',
                  uiString: loc(translationFeedbackCategoryIncorrectDifficult),
              },
              {
                  logString: 'MissingIncomplete',
                  uiString: loc(translationFeedbackCategoryMissingIncomplete),
              },
              { logString: 'AlreadyLang', uiString: loc(translationFeedbackCategoryAlreadyLang) },
              { logString: 'Other', uiString: loc(translationFeedbackCategoryOther) },
          ]
        : [
              { logString: 'Readability', uiString: loc(translationFeedbackCategoryReadability) },
              { logString: 'Formatting', uiString: loc(translationFeedbackCategoryFormatting) },
              { logString: 'Other', uiString: loc(translationFeedbackCategoryOther) },
          ];

    const dialogparams: FeedbackDialogParams = {
        title: loc(translationFeedbackDialogTitle),
        subTitle: loc(translationFeedbackDialogSubtitle),
        ghostText: loc(translationFeedbackDialogGhostText),
        categories: feedbackCategories,
        odsFeedbackOverrides: {
            symptomName: 'inlineTranslation',
        },
        ...(isFeatureEnabled('rp-inlineTranslation-DonateContent') && {
            donationText: loc(translationFeedbackDonationMessage),
            donationJson: { messageContent: props.messageContent },
        }),
    };
    return (
        <div className={styles.translationFeedback}>
            <FeedbackRibbon
                ribbonMessage={loc(translationFeedbackRibbonMessage)}
                feature="inlineTranslation"
                subFeature="inlineTranslation"
                metadata={getMetadata(props)}
                thankYouMessage={loc(translationFeedbackThankYouMessage)}
                moreFeedbackRibbonMessage={loc(translationFeedbackMoreFeedbackMessage)}
                noFeedbackDialogParams={dialogparams}
                yesCallBack={onYes}
                noCallBack={onNo}
            />
        </div>
    );
}
